import NotFound from './pages/NotFoundPage';
import CreateProceeding from './pages/CreateProceedingPage';
import Home from './pages/HomePage';
import SearchDocument from './pages/SearchDocumentPage';

const routes = [
  { path: '/hearing', component: Home, exact: true },
  { path: '/hearing/proceeding/', component: CreateProceeding, exact: true },
  { path: '/hearing/searchDocument', component: SearchDocument, exact: true},
  { path: '*', component: NotFound },
];

export default routes;
